import React from "react";
import styled from "styled-components";

const Holder = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
`;

const Illustration = styled.img`
  width: 100%;
  max-width: 664px;
  height: auto;
  object-fit: contain;
  pointer-events: none;
  margin-top: -20px;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 0;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  max-width: 518px;
  width: 100%;
  padding: 0 24px;
  margin-top: 80px;

  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

const Title = styled.h1`
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: normal;
  text-transform: uppercase;
  color: #181122;
  margin: 0;
`;

const Underline = styled.div`
  width: 96px;
  height: 3px;
  background: #57c4c2;
  margin-top: 8px;
`;

const Message = styled.p`
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: #181122;
  margin: 0;
`;

const CTAButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  background: #73cecc;
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #000;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: #57c4c2;
  }
`;

export default function Blocked() {
  return (
    <Holder>
      <Illustration
        src="/img/blocked_illustration.png"
        alt="Ilustração de acesso bloqueado"
      />
      <TextContent>
        <div>
          <Title>Acesso Bloqueado</Title>
          <Underline />
        </div>
        <Message>
          O acesso à plataforma, por sua empresa, foi temporariamente bloqueado
          por falha no pagamento. Resolva este bloqueio com o time de suporte.
        </Message>
        <CTAButton href="mailto:oi@zagapp.com.br">
          Entrar em contato com o suporte
        </CTAButton>
      </TextContent>
    </Holder>
  );
}
